import { createStore } from "vuex"
import AppStore from "@/store/AppStore"
import UserStore from "@/store/UserStore"
import NotificationsStore from "@/store/NotificationsStore"

export default createStore({
    modules: [AppStore, UserStore, NotificationsStore],
})
